import { QueryHookOptions } from '@apollo/client';
import { getSelectOptions } from '@anytag/shared-utils';
import { Query, useAllAdvertisersForSearchQuery, QueryallAdvertisersForSearchArgs } from '@anytag/graphql';

export const useAllAdvertisersForSearchOptions = (
  options?: QueryHookOptions<Query, QueryallAdvertisersForSearchArgs>
) => {
  const { data, loading } = useAllAdvertisersForSearchQuery({ fetchPolicy: 'cache-and-network', ...options });

  return {
    loading,
    allAdvertiserOptions: getSelectOptions(data?.allAdvertisersForSearch.advertisers)
  };
};
